import Axios  from "axios"

export const getCounters = () => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'COUNTERS_GET_SUCCESS',
                payload: data.counters
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'           
        })         
    }
}

export const getCounterDetail = (counter) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/get/'+ counter, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'COUNTER_GET_DETAIL_SUCCESS',
                payload: data.counter
            })             
        }

    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'           
        })         
    }
}

export const getCountersByFarm = (farm) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/getbyfarm/'+ farm, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'COUNTERS_GET_BY_FARM_SUCCESS',
                payload: data.counters
            })             
        }

    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'           
        })         
    }
}

export const addCounter = (name, description, farm, reading) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/register', {
                name: name,
                description: description,
                farm: farm,
                reading: reading
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newCounter = {
                _id: data.id,
                name: name,
                description: description,
                farm: farm,
                reading: reading
            }
            dispatch({
                type: 'COUNTER_ADD_SUCCESS',
                payload: newCounter
            })
        }
    } catch (error) {
        dispatch({
            type: 'COUNTER_FAIL'
        })
    }
}

export const editCounter = (name, description, farm, reading, idCounter) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/edit/' + idCounter, {
                name: name,
                description: description,
                farm: farm,
                reading: reading
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'COUNTER_EDIT_SUCCESS',
            payload: {
                name: name,
                description: description,
                farm: farm,
                reading: reading,
                _id: idCounter
            }
        })
    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'
        })
    }
}

export const deleteRead = (idCounter, idReading) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {
            data
        } = await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/editread/' + idCounter, {
                idReading: idReading
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'COUNTER_EDIT_SUCCESS',
            payload: data.counter
        })
    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'
        })
    }
}

export const addRegisterCounter = (quantity, user, type, idCounter) => async (dispatch) => {
    dispatch({
        type: 'COUNTER_LOADING'
    })
    try {
        const {
            data
        } = await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/insertregister/' + idCounter, {
                quantity: quantity,
                user: user,
                type: type
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'COUNTER_EDIT_SUCCESS',
            payload: data.counter
        })
    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'
        })
    }
}

export const removeCounter = (idCounter) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/counter/remove/' + idCounter, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'COUNTER_DELETE_SUCCESS',
                payload: {
                    idCounter: idCounter,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'COUNTER_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'COUNTER_ERROR'
        })
    }
}